export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			'items': [
				{
					'title': 'Pages',
					'root': true,
					'icon-': 'flaticon-add',
					'toggle': 'click',
					'custom-class': 'kt-menu__item--active',
					'alignment': 'left',
					'translate': 'MENU.PAGES',
					'submenu': {
						'type': 'classic',
						'alignment': 'left',
						'items': [
							{
								'title': 'My Account',
								'icon': 'flaticon-file',
								'page': 'index'
							},
							{
								'title': 'Task Manager',
								'icon': 'flaticon-diagram',
								'badge': {
									'type': 'kt-badge--success',
									'value': '2'
								}
							},
							{
								'title': 'Team Manager',
								'icon': 'flaticon-business',
								'submenu': {
									'type': 'classic',
									'alignment': 'right',
									'bullet': 'line',
									'items': [
										{
											'title': 'Add Team Member',
											'icon': ''
										},
										{
											'title': 'Edit Team Member',
											'icon': ''
										},
										{
											'title': 'Delete Team Member',
											'icon': ''
										},
										{
											'title': 'Team Member Reports',
											'icon': ''
										},
										{
											'title': 'Assign Tasks',
											'icon': ''
										},
										{
											'title': 'Promote Team Member',
											'icon': ''
										}
									]
								}
							},
							{
								'title': 'Projects Manager',
								'page': '#',
								'icon': 'flaticon-chat-1',
								'submenu': {
									'type': 'classic',
									'alignment': 'right',
									'bullet': 'dot',
									'items': [
										{
											'title': 'Latest Projects',
											'icon': ''
										},
										{
											'title': 'Ongoing Projects',
											'icon': ''
										},
										{
											'title': 'Urgent Projects',
											'icon': ''
										},
										{
											'title': 'Completed Projects',
											'icon': ''
										},
										{
											'title': 'Dropped Projects',
											'icon': ''
										}
									]
								}
							},
							{
								'title': 'Create New Project',
								'icon': 'flaticon-users'
							}
						]
					}
				},
				{
					'title': 'Features',
					'root': true,
					'icon-': 'flaticon-line-graph',
					'toggle': 'click',
					'alignment': 'left',
					'translate': 'MENU.FEATURES',
					'submenu': {
						'type': 'mega',
						'width': '1000px',
						'alignment': 'left',
						'columns': [
							{
								'heading': {
									'heading': true,
									'title': 'Task Reports',
									'bullet': 'dot'
								},
								'items': [
									{
										'title': 'Latest Tasks',
										'icon': 'flaticon-map'
									},
									{
										'title': 'Pending Tasks',
										'icon': 'flaticon-user'
									},
									{
										'title': 'Urgent Tasks',
										'icon': 'flaticon-clipboard'
									},
									{
										'title': 'Completed Tasks',
										'icon': 'flaticon-graphic-1'
									},
									{
										'title': 'Failed Tasks',
										'icon': 'flaticon-graphic-2'
									}
								]
							},
							{
								'bullet': 'line',
								'heading': {
									'heading': true,
									'title': 'Profit Margins',
									'bullet': 'dot'
								},
								'items': [
									{
										'title': 'Overall Profits',
										'icon': ''
									},
									{
										'title': 'Gross Profits',
										'icon': ''
									},
									{
										'title': 'Nett Profits',
										'icon': ''
									},
									{
										'title': 'Year to Date Reports',
										'icon': ''
									},
									{
										'title': 'Quarterly Profits',
										'icon': ''
									},
									{
										'title': 'Monthly Profits',
										'icon': ''
									}
								]
							},
							{
								'bullet': 'dot',
								'heading': {
									'heading': true,
									'title': 'Staff Management',
									'bullet': 'dot'
								},
								'items': [
									{
										'title': 'Top Management',
										'icon': ''
									},
									{
										'title': 'Project Managers',
										'icon': ''
									},
									{
										'title': 'Development Staff',
										'icon': ''
									},
									{
										'title': 'Customer Service',
										'icon': ''
									},
									{
										'title': 'Sales and Marketing',
										'icon': ''
									},
									{
										'title': 'Executives',
										'icon': ''
									}
								]
							},
							{
								'heading': {
									'heading': true,
									'title': 'Tools',
									'icon': '',
									'bullet': 'dot'
								},
								'items': [
									{
										'title': 'Analytical Reports',
										'icon': ''
									},
									{
										'title': 'Customer CRM',
										'icon': ''
									},
									{
										'title': 'Operational Growth',
										'icon': ''
									},
									{
										'title': 'Social Media Presence',
										'icon': ''
									},
									{
										'title': 'Files and Directories',
										'icon': ''
									},
									{
										'title': 'Audit & Logs',
										'icon': ''
									}
								]
							}
						]
					}
				},
				{
					'title': 'Apps',
					'root': true,
					'icon-': 'flaticon-paper-plane',
					'toggle': 'click',
					'alignment': 'left',
					'translate': 'MENU.APPS',
					'submenu': {
						'type': 'classic',
						'alignment': 'left',
						'items': [
							{
								'title': 'Reporting',
								'icon': 'flaticon-business'
							},
							{
								'title': 'Social Presence',
								'page': 'components/datatable_v1',
								'icon': 'flaticon-computer',
								'submenu': {
									'type': 'classic',
									'alignment': 'right',
									'items': [
										{
											'title': 'Reached Users',
											'icon': 'flaticon-users'
										},
										{
											'title': 'SEO Ranking',
											'icon': 'flaticon-interface-1'
										},
										{
											'title': 'User Dropout Points',
											'icon': 'flaticon-lifebuoy'
										},
										{
											'title': 'Market Segments',
											'icon': 'flaticon-graphic-1'
										},
										{
											'title': 'Opportunity Growth',
											'icon': 'flaticon-graphic'
										}
									]
								}
							},
							{
								'title': 'Sales & Marketing',
								'icon': 'flaticon-map'
							},
							{
								'title': 'Campaigns',
								'icon': 'flaticon-graphic-2',
								'badge': {
									'type': 'kt-badge--success',
									'value': '3'
								}
							},
							{
								'title': 'Deployment Center',
								'page': '',
								'icon': 'flaticon-infinity',
								'submenu': {
									'type': 'classic',
									'alignment': 'right',
									'items': [
										{
											'title': 'Merge Branch',
											'icon': 'flaticon-add',
											'badge': {
												'type': 'kt-badge--danger',
												'value': '3'
											}
										},
										{
											'title': 'Version Controls',
											'icon': 'flaticon-signs-1'
										},
										{
											'title': 'Database Manager',
											'icon': 'flaticon-folder'
										},
										{
											'title': 'System Settings',
											'icon': 'flaticon-cogwheel-2'
										}
									]
								}
							}
						]
					}
				}
			]
		},
		aside: {
			self: {},
			items: [

				{
					title: 'My Profile',
					desc: 'My Profile',
					root: true,
					page: 'my-profile',
					icon: 'flaticon-user'
				},

				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon2-architecture-and-city',
					page: 'dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
				},


				{
					title: 'Customers',
					desc: 'Maharah Customers',
					root: true,
					page: 'customer',
					icon: 'flaticon-customer'
				},
				{
					title: 'Customer Wallet',
					desc: 'Customer Wallet',
					root: true,
					page: 'customer-wallet',
					icon: 'flaticon-user'
				},
				{
					title: 'Vendors',
					desc: 'Maharah Vendors',
					root: true,
					page: 'vendors',
					icon: ' flaticon2-user '
				},

				{
					title: 'Vendor Wallet',
					desc: 'Vendor Wallet',
					root: true,
					page: 'vendor-wallet',
					icon: 'flaticon-user'
				},
				{
					title: 'Vendor Online Transaction',
					desc: 'Vendor Online Transaction',
					root: true,
					page: 'vendor-online-transaction',
					icon: 'flaticon-user'
				},
				{
					title: 'Customer Online Transaction',
					desc: 'Customer Online Transaction',
					root: true,
					page: 'customer-online-transaction',
					icon: 'flaticon-user'
				},
				{
					title: 'Notifications',
					desc: 'Notifications',
					root: true,
					page: 'notifications',
					icon: 'flaticon-user'
				},
				{
					title: 'Users Reports',
					desc: 'Users Reports',
					root: true,
					page: 'users-reports',
					icon: 'flaticon-user-settings  '
				},

				{
					title: 'Accounts Reports',
					desc: 'Accounts Reports',
					root: true,
					page: 'accounts-reports',
					icon: 'flaticon-user-settings  '
				},
				{
					title: 'Categories',
					desc: 'Maharah Categories',
					root: true,
					page: 'categories',
					icon: ' flaticon-squares-3 '
				},

				{
					title: 'Vendor Role',
					desc: 'Maharah Categories',
					root: true,
					page: 'vendor-role',
					icon: 'flaticon-user-settings  '
				},
				{
					title: 'Customer Classes',
					desc: 'Maharah Customer Classes',
					root: true,
					page: 'customer-class',
					icon: ' flaticon-user-ok   '
				},

				{
					title: 'Vendor Classes',
					desc: 'Maharah Vendor Classes',
					root: true,
					page: 'vendor-class',
					icon: ' flaticon-user-ok   '
				},
				{
					title: 'Jobs',
					desc: 'Maharah Jobs',
					root: true,
					page: 'jobs',
					icon: 'flaticon-suitcase'
				},
				{
					title: 'Companies',
					desc: 'Maharah Companies',
					root: true,
					page: 'companies',
					icon: 'flaticon-suitcase'
				},
				{
					title: 'Action Required',
					desc: 'Action Required',
					root: true,
					page: 'action-required',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Coupons',
					desc: 'Maharah Coupons',
					root: true,
					page: 'coupons',
					icon: ' flaticon2-list-2'
				},

				{
					title: 'Packages',
					desc: 'Maharah Packages',
					root: true,
					page: 'packages',
					icon: '   flaticon-bag'
				},
				{
					title: 'Cities',
					desc: 'Maharah Cities',
					root: true,
					page: 'cities',
					icon: 'flaticon-map-location'
				},
				// {
				// 	title: 'Zones',
				// 	desc: 'Maharah Cities',
				// 	root: true,
				// 	page: 'zones',
				// 	icon: 'flaticon-map-location'
				// },

				{
					title: 'Nationality',
					desc: 'Maharah Nationality',
					root: true,
					page: 'nationality',
					icon: 'flaticon-map-location'
				},

				{
					title: 'Cancel Reasons',
					desc: 'Cancel Reasons',
					root: true,
					page: 'cancel-reasons',
					icon: 'flaticon-map-location'
				},
				{
					title: 'Customer Cancel Reasons',
					desc: 'Customer Cancel Reasons',
					root: true,
					page: 'customer-cancel-reasons',
					icon: 'flaticon-cancel'
				  },									
				{
					title: 'Review Data',
					desc: 'Review Data',
					root: true,
					page: 'review-data',
					icon: 'flaticon-map-location'
				},
				{
					title: 'Templates',
					desc: 'Templates',
					root: true,
					page: 'templates',
					icon: 'flaticon-map-location'
				},
				{
					title: 'Default Time Slots',
					desc: 'Default Time Slots',
					root: true,
					page: 'default-time-slots',
					icon: 'flaticon-map-location'
				},
				{
					title: 'Settings',
					desc: 'Settings',
					root: true,
					page: 'settings',
					icon: 'flaticon-settings'
				}, 
				{
					title: 'LocalisationFiles',
					desc: 'LocalisationFiles',
					root: true,
					page: 'localisationfiles',
					icon: 'flaticon-settings'
				},
				{
					title: 'Admin Users',
					desc: 'Admin Users',
					root: true,
					page: 'admin-users',
					icon: 'flaticon-user-ok '
				},
				{
					title: 'Admin Roles',
					desc: 'Admin Roles',
					root: true,
					page: 'admin-roles',
					icon: 'flaticon-user-ok '
				},
				{
					title: 'Cancelation',
					desc: 'Cancelation',
					root: true,
					page: 'cancelation',
					icon: 'flaticon-ok '
				},
				{
					title: 'Vendor Loyalty History',
					desc: 'Vendor Loyalty History',
					root: true,
					page: 'vendor-loyalty-history',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Customer Loyalty History',
					desc: 'Customer Loyalty History',
					root: true,
					page: 'customer-loyalty-history',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Loyalty Settings',
					desc: 'Loyalty Settings',
					root: true,
					page: 'loyalty-setting',
					icon: 'flaticon-settings'
				},
				{
					title: 'Special Dates',
					desc: 'Special Dates',
					root: true,
					page: 'special-dates',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Operation Performance',
					desc: 'Operation Performance',
					root: true,
					page: 'operation-performance',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Transfer Request',
					desc: 'Transfer Request',
					root: true,
					page: 'transfer-request',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Special Coupon',
					desc: 'Special Coupon',
					root: true,
					page: 'special-coupon',
					icon: 'flaticon-calendar'
				},
				{
					title: 'Role Permissions',
					desc: 'Role Permissions',
					root: true,
					page: 'role-permissions',
					icon: 'flaticon-user-ok '
				},
				{
					title: 'Logout',
					desc: 'Log out from the application',
					root: true,
					icon: 'flaticon-logout', 
					 action: 'logout'
				  }
			]
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
